export default "__VITE_ASSET__682ffbde__"